import React, {useContext,useEffect, useState,useRef} from 'react'
import moment from 'moment';
import $ from 'jquery'
import axios from "axios";
import DataContext from "./../../data/DataContext";
import LothunService from '../../Services/Lothun.service';
import Swal from 'sweetalert2'
import './../../css/lothun.css'

import 'bootstrap-daterangepicker/daterangepicker.css';
import DateRangePicker from 'react-bootstrap-daterangepicker';

function LothunWin() {
  const dataConf = useContext(DataContext)
  const lothunService = new LothunService();

  const [lothunItem,setLothunItem] = useState([])

  const firstUpdate = useRef(true);
  useEffect(()=>{
    // if (firstUpdate.current) {
    //   firstUpdate.current = false;
    //   return;
    // }
    fetchLotHun(moment().format('DD-MM-YYYY'))
  },[])

  const searchLothun = (e)=>{
      e.preventDefault()
      fetchLotHun(e.target.p_date.value)
      
  }

  const fetchLotHun = (date)=>{
    dataConf.blockUI(true)
    lothunService.listing(date).then((result) => {
          if (result.success){
            // console.log(result)
            setLothunItem(result.data)
            dataConf.blockUI()
          }
          else{
            Swal.fire({
              title: result.message,
              text:'',
              icon: 'warning',
              confirmButtonText: 'ตกลง',
              confirmButtonColor: '#890000',
          })
        }
    });
  }

  const submit_ok = (ok_id,g_process) => {
    Swal.fire({
      title: 'ยืนยัน',
      text: 'คุณต้องการบันทึกผลรางวัลนี้หรือไม่',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'ตกลง',
      cancelButtonText: 'ยกเลิก',
    }).then((result) => {
      if (result.isConfirmed) {
        let reward1 = $('#inp_t1_'+ok_id).val()
        let reward2 = $('#inp_t2_'+ok_id).val()
        console.log(reward1,reward2,g_process)
        console.log(isNaN(reward1),isNaN(reward2))
        if ( reward1 !== '*' || reward2 !== '*'){
          if ( reward1 === '' || reward2 === '' || isNaN(reward1) || isNaN(reward2)){
          
            Swal.fire({
              title: 'ผิดพลาด กรอกข้อมูลไม่ถูกต้อง !!',
              text:'',
              icon: 'warning',
              confirmButtonText: 'ตกลง',
              confirmButtonColor: '#890000',
            })
            return
          }
        

          if( (g_process === 4 && reward1.length != 6) || (g_process === 3 && reward1.length != 4) || (g_process === 2 && reward1.length != 3) || reward2.length != 2){
            Swal.fire({
              title: 'ผิดพลาด กรอกข้อมูลไม่ถูกต้อง !!',
              text:'',
              icon: 'warning',
              confirmButtonText: 'ตกลง',
              confirmButtonColor: '#890000',
            })
            return
          }
        }

        const p_ok_number = reward1+","+reward2
        const payload = {
          p_ok_id: ok_id,
          p_ok_number:p_ok_number,
        }
        dataConf.blockUI(true)
        lothunService.process_save(payload).then((result) => {
          dataConf.blockUI()
          if (result.success){
            fetchLotHun($('#p_date').val())
            Swal.fire({
              title: result.message,
              text:'',
              icon: 'success',
              confirmButtonText: 'ตกลง',
              confirmButtonColor: 'green',
            })
          }
          else{
            Swal.fire({
              title: result.message,
              text:'',
              icon: 'warning',
              confirmButtonText: 'ตกลง',
              confirmButtonColor: '#890000',
            })
          }
        });
      }
    });
  }

  const process_ok =  (e,ok_id,limit_time,g_process,zone)=>{
    Swal.fire({
      title: 'ยืนยัน',
      text: 'คุณต้องการคำนวนผลรางวัลนี้หรือไม่',
      icon: 'warning',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'ตกลง',
      cancelButtonText: 'ยกเลิก',
    }).then(async (result) => {
      if (result.isConfirmed) {
          // console.log('process_ok')
          dataConf.blockUI(true)
          // access key ยังไม่เส็จ
          const payload = {
            username: dataConf.a_user,
            password: dataConf.a_pass,
          }
          const response = await axios.post(`${dataConf.ApiFrontEnd}/sa/access-key`,payload,{ 
            headers: {"Content-Type": "application/json"},
          })
          .then((res)=>{
            dataConf.blockUI()
              const payload_p = {
                p_ok_id: ok_id,
                p_a_id: dataConf.a_id,
                p_access_key: res.data.key,
                p_zone: zone,
                p_g_proccess: g_process
              }
              // console.log(payload_p)
              lothunService.process_ok(payload_p).then((result) => {
                if (result.success){
                  // console.log(result)
                  fetchLotHun($('#p_date').val())
                  Swal.fire({
                    title: result.message,
                    text:'',
                    icon: 'success',
                    confirmButtonText: 'ตกลง',
                    confirmButtonColor: 'green',
                  })
                }else{
                  Swal.fire({
                    title: result.message,
                    text:'',
                    icon: 'warning',
                    confirmButtonText: 'ตกลง',
                    confirmButtonColor: '#890000',
                  })
                }
            });
          })
          .catch((error) => {
            dataConf.blockUI()
            // console.log(error)
            Swal.fire({
                  title: 'ผิดพลาด !! กรุณาติดต่อแอดมิน ',
                  text:'',
                  icon: 'warning',
                  confirmButtonText: 'ตกลง',
                  confirmButtonColor: '#890000',
              })
          });
      }
    })
  }

  const processNew = (ok_id, g_process, zone)=>{
    Swal.fire({
      title: 'รหัสความปลอดภัย',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'ตกลง',
      showLoaderOnConfirm: true,
      cancelButtonText: 'ยกเลิก',
      preConfirm: (pass_code) => {
        if(pass_code === "") {
          Swal.fire('ผิดพลาด', "รหัสความปลอดภัยไม่ถูกต้อง")
          return;
        }

        dataConf.blockUI(true)
        const payload = {
          p_ok_id: ok_id,
          p_a_id: dataConf.a_id,
          p_zone: zone,
          p_g_proccess: g_process,
          p_g_pass: pass_code
        }

        lothunService.process_mn(payload).then((result) => {
          dataConf.blockUI()
          if (result.success){
            Swal.fire({
              title: result.message,
              text:'',
              icon: 'success',
              confirmButtonText: 'ตกลง',
              confirmButtonColor: 'green',
            })
          }
          else{
            Swal.fire({
              title: result.message,
              text:'',
              icon: 'warning',
              confirmButtonText: 'ตกลง',
              confirmButtonColor: '#890000',
            })
          }
        });
      }
    })
  }

  const chenge_limit_data = (ok_id) => {
    
    Swal.fire({
      title: 'ยืนยัน',
      text: 'คุณต้องการเปลี่ยนแปลงวันที่ปิดรับหรือไม่',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'ตกลง',
      cancelButtonText: 'ยกเลิก',
    }).then((result) => {
      if (result.isConfirmed) {
        const limit_date = $('#input_date_limit_'+ok_id).val()
        const payload = {
          p_id: ok_id,
          p_limit_time_hun: limit_date,
        }
        dataConf.blockUI(true)
        lothunService.process_control(payload).then((result) => {
          dataConf.blockUI()
            if (result.success){
              // console.log(result)
              Swal.fire({
                title: result.message,
                text:'',
                icon: 'success',
                confirmButtonText: 'ตกลง',
                confirmButtonColor: 'green',
              })
            }else{
              Swal.fire({
                title: result.message,
                text:'',
                icon: 'warning',
                confirmButtonText: 'ตกลง',
                confirmButtonColor: '#890000',
              })
            }
        });
      }
    });
  }

  const close_lotto = (ok_id,status) => {
    Swal.fire({
      title: 'ยืนยัน',
      text: 'คุณต้องการเปลี่ยนแปลงวันที่ปิดรับหรือไม่',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'ตกลง',
      cancelButtonText: 'ยกเลิก',
    }).then((result) => {
      if (result.isConfirmed) {
        const limit_date = $('#input_date_limit_'+ok_id).val()
        const payload = {
          p_id: ok_id,
          p_status: status,
        }
        dataConf.blockUI(true)
        lothunService.process_control(payload).then((result) => {
          dataConf.blockUI()
            if (result.success){
              // console.log(result)
              fetchLotHun($('#p_date').val())
              Swal.fire({
                title: result.message,
                text:'',
                icon: 'success',
                confirmButtonText: 'ตกลง',
                confirmButtonColor: 'green',
              })
            }else{
              Swal.fire({
                title: result.message,
                text:'',
                icon: 'warning',
                confirmButtonText: 'ตกลง',
                confirmButtonColor: '#890000',
              })
            }
        });
      }
    });
  }

  const reBill = (_id)=>{
    $('#btn_re_'+_id).toggleClass('d-none')
    $('#btn_new_proc_'+_id).toggleClass('d-none')
    $('#btn_re_proc_'+_id).toggleClass('d-none')
    $('#l_re_proc_'+_id).toggleClass('d-none')
    $('#inp_t1_'+_id).attr('readonly',false)
    $('#inp_t2_'+_id).attr('readonly',false)
  }

  const reProcess = (e,_id)=>{
    const g_process = e.target.value
    // console.log(g_process)
    Swal.fire({
      title: 'รหัสความปลอดภัย',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'ตกลง',
      showLoaderOnConfirm: true,
      cancelButtonText: 'ยกเลิก',
      preConfirm: (pass_code) => {
          if(pass_code == "")
          {
            Swal.fire('ผิดพลาด', "รหัสความปลอดภัยไม่ถูกต้อง")
            return;
          }
          dataConf.blockUI(true)
          let reward1 = $('#inp_t1_'+_id).val()
          let reward2 = $('#inp_t2_'+_id).val()
          const p_ok_number = reward1+","+reward2

          if ( reward1 !== '*' || reward2 !== '*'){
            if((g_process === 4 && reward1.length != 6) || (g_process === 3 && reward1.length != 4) || (g_process === 2 && reward1.length != 3) || reward2.length != 2){
              Swal.fire({
                title: 'ผิดพลาด กรอกข้อมูลไม่ถูกต้อง !!',
                text:'',
                icon: 'warning',
                confirmButtonText: 'ตกลง',
                confirmButtonColor: '#890000',
              })
              return
            }
          }

          const payload = {
              p_ok_id: _id,
              p_code: pass_code,
              p_g_process: g_process,
              p_ok_number:p_ok_number,
              p_a_id: dataConf.a_id,
          }

          lothunService.process_reset(payload).then((result) => {
            dataConf.blockUI()
              if (result.success){
                $('#btn_re_'+_id).toggleClass('d-none')
                $('#btn_re_proc_'+_id).toggleClass('d-none')
                $('#l_re_proc_'+_id).toggleClass('d-none')
                $('#inp_t1_'+_id).attr('readonly',true)
                $('#inp_t2_'+_id).attr('readonly',true)
                fetchLotHun($('#p_date').val())
                Swal.fire({
                  title: result.message,
                  text:'',
                  icon: 'success',
                  confirmButtonText: 'ตกลง',
                  confirmButtonColor: 'green',
                })
              }
              else{
                Swal.fire({
                  title: result.message,
                  text:'',
                  icon: 'warning',
                  confirmButtonText: 'ตกลง',
                  confirmButtonColor: '#890000',
                })
              }
      });
      }
    })
    
  }


  return (
    <div className="m-2" id="lothun-win">
        <form onSubmit={searchLothun} id="frm_s_lothun">
          <div className="row g-3 align-items-center">
            <div className="col-auto">
              <label htmlFor="" className="col-form-label">ผลรางวัลวันที่:</label>
            </div>
              <div className="col-auto">
              <div className="input-group">
                <DateRangePicker initialSettings={{ singleDatePicker:true,startDate: moment().toDate(),maxDate:moment().toDate(), locale: {...dataConf.localSet,format: 'DD-MM-YYYY'}}}>
                  <input type="text" className="form-control form-control-sm" id="p_date" />
                </DateRangePicker>
                <span className="input-group-text" id="basic-addon2"><img src="/calendar.png"/></span>
              </div>
            </div>
            <div className="col-auto">
              <button type="submit" className="btn btn-warning btn-sm ">ค้นหา</button>
            </div>
          </div>
        </form>
      <div className="bg-title text-light text-center fw-bold fs-6 p-2 mt-2">
          ประเภทหวย
      </div>
      <div className="row mt-2">
        {lothunItem.map((lothun)=>{
            const lot = lothun.ok_number.split(',')
            return (
              <div className="col-lg-4 col-md-6 col-sm-6 mb-3" key={lothun._id}>
                <div className="card text-center">
                  <h6 className="card-header">{lothun.ok_name} <small> เวลา {moment(lothun.limit_time).format('DD/MM/YYYY HH:mm:ss')}</small></h6>
                  <div className="card-body pt-1">
                    <div className="row">
                      <div className="col-sm-7">
                        <div className="row">
                          <div className="col-12"><small>( {lothun._id} )</small></div>
                          <div className="col-6 mb-1">
                            <label> {lothun.zone == 22 ? '6' : (lothun.g_process === 2?'3':'4')} ตัว</label>
                            <input className="form-control form-control-sm text-center" type="text" maxLength={lothun.zone == 22 ? '6' : (lothun.g_process === 2?'3':'4')} id={`inp_t1_${lothun._id}`} defaultValue={lot[0]} readOnly={lothun.active?true:false}/>
                          </div>
                          <div className="col-6 mb-1">
                            <label> 2 ตัว</label>
                            <input className="form-control form-control-sm text-center" type="text" maxLength="2" id={`inp_t2_${lothun._id}`} defaultValue={lot[1]} readOnly={lothun.active?true:false}/>
                          </div>
                          <div className="col-12 mb-1">
                            <DateRangePicker initialSettings={{ timePicker: true,timePicker24Hour: true,singleDatePicker:true,startDate: moment(lothun.limit_time), locale: {...dataConf.localSet,format: 'DD/MM/YYYY HH:mm'}}}>
                              <input className="form-control form-control-sm text-center" id={`input_date_limit_${lothun._id}`} readOnly/>
                            </DateRangePicker>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-5 m-auto p-auto">
                        <div className="row mt-3">
                          {lothun.active === 1 ? 
                              <>
                                <div className="col-6 mb-1" id={`btn_re_${lothun._id}`}>
                                  <button className="btn btn-warning btn-sm w-100"  onClick={()=>{reBill(lothun._id)}}> รีบิล </button>
                                </div>
                                <div className="col-6 mb-1 d-none" id={`btn_re_proc_${lothun._id}`} >
                                  <button className="btn btn-warning btn-sm w-100" value={lothun.g_process} onClick={(e)=>{reProcess(e,lothun._id)}}> คำนวน </button>
                                </div>
                                <div className="col-6 mb-1" id={`l_re_proc_${lothun._id}`}>
                                  <input type="button"  value="จ่ายแล้ว" className={`btn btn-sm btn-light border ml-1 rebill_ok_${lothun._id}`}  disabled={true} /> 
                                </div>
                                <div className="col-6 mb-1" id={`btn_new_proc_${lothun._id}`}>
                                  <button onClick={()=>processNew(lothun._id, lothun.g_process, lothun.zone)} className="btn btn-sm btn-success w-100">คำนวณใหม่</button>
                                </div>
                              </>
                          : 
                              <>
                                <div className="col-6 mb-1">
                                  <button className="btn btn-success btn-sm w-100" onClick={()=>{submit_ok(lothun._id,lothun.g_process)}}> บันทึก </button>
                                </div>
                                <div className="col-6 mb-1">
                                  <button className="btn btn-warning btn-sm w-100" onClick={(e)=>{process_ok(e,lothun._id,lothun.limit_time,lothun.g_process,lothun.zone)}}> คำนวน </button>
                                </div>
                              
                                <div className="col-6 mb-1">
                                  <button type="button"  name="b_ok" id="b_ok" value="บันทึก" data-ok_id="${value._id}" className="btn btn-sm btn-warning ml-1 w-100" onClick={()=>{chenge_limit_data(lothun._id)}}>แก้ไข</button>
                                </div>
                                
                                {lothun.status === 1? 
                                  <>
                                    <div className="col-6 mb-1">
                                      <button type="button"  value="1" className="btn btn-sm btn-danger ml-1 w-100" onClick={()=>{close_lotto(lothun._id,0)}}>  ปิดหวย  </button>
                                    </div>
                                  </>
                                :
                                  <>
                                    <div className="col-6 mb-1">
                                      <button type="button"  value="0" className="btn btn-sm btn-success ml-1 w-100" onClick={()=>{close_lotto(lothun._id,1)}}>  เปิดหวย </button>
                                    </div>
                                  </>
                                }
                            </>
                          }
                          
                          {/* <div className="col-6 mb-1">
                            <button className="btn btn-warning btn-sm w-100" > แก้ไข </button>
                          </div>
                          <div className="col-6 mb-1">
                            <button className="btn btn-danger btn-sm w-100" > ปิดหวย </button>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
        })}
        
      </div>
      

    </div>
  )
}

export default LothunWin